import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Chats() {
  const navigate = useNavigate();

  // Get all usernames from localStorage keys
  const usernames = Array.from(new Set(
    Object.keys(localStorage)
      .map(key => key.match(/^(.+)-otherName$/))
      .filter(Boolean)
      .map(match => match[1])
  ));

  const chatPartners = usernames.map(username => ({
    username,
    name: localStorage.getItem(`${username}-otherName`) || username,
    picture: localStorage.getItem(`${username}-otherImage`) || ''
  }));

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Chats</h2>
        <button
          className="btn btn-primary"
          style={{ borderRadius: '50%', width: 40, height: 40, fontSize: '1.5em', padding: 0 }}
          onClick={() => navigate('/settings')}
          title="Add new chat"
        >
          +
        </button>
      </div>
      <ul className="list-group">
        {chatPartners.map(partner => (
          <li
            key={partner.username}
            className="list-group-item list-group-item-action d-flex align-items-center"
            style={{ cursor: 'pointer', position: 'relative' }}
          >
            <img
              src={partner.picture}
              alt={partner.name}
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                objectFit: 'cover',
                marginRight: 16,
                border: '2px solid #ddd'
              }}
              onClick={() => navigate(`/chats/${partner.username}`)}
            />
            <span
              style={{ fontWeight: 'bold', fontSize: '1.1em', flex: 1 }}
              onClick={() => navigate(`/chats/${partner.username}`)}
            >
              {partner.name}
            </span>
            {/* <span
              className="ms-2 text-muted"
              onClick={() => navigate(`/chats/${partner.username}`)}
              style={{ cursor: 'pointer' }}
            >
              @{partner.username}
            </span> */}
            <button
              type="button"
              className="btn btn-link ms-3"
              style={{ fontSize: '1em' }}
              title="Delete chat"
              onClick={() => {
                if (window.confirm(`Are you sure you want to delete all data for "${partner.name}"?`)) {
                  Object.keys(localStorage)
                    .filter(key => key.startsWith(`${partner.username}-`))
                    .forEach(key => localStorage.removeItem(key));
                  window.location.reload();
                }
              }}
            >
              🗑️
            </button>
          </li>
        ))}
        {chatPartners.length === 0 && (
          <li className="list-group-item text-center text-muted">
            No chats yet. Click + to add a new chat partner.
          </li>
        )}
      </ul>
    </div>
  );
}